import { WithGlobalCss } from "@sgwt-widget/core";
import { LicenseManager } from "ag-grid-enterprise/main";
import { AgFormat } from "../../utils/agGridFormat";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Component, h } from "preact";
import { Format } from "../../utils/format";
import { IHeader } from "./index";
import { ChangeDetectionStrategyType } from "ag-grid-react/lib/changeDetectionService";
import * as XLSX from "xlsx";
import * as css from "./spl-ag-grid-basic.less";
import { AgGridUserPreference } from "../../sg-dashboard/userPreference/userPreference.typings";
import { isArray } from "highcharts";
LicenseManager.setLicenseKey(
  "SHI_International_France__on_behalf_of_SOCIETE_GENERALE_ICT_3Devs9_November_2019__MTU3MzI1NzYwMDAwMA==8f57eed23862f998eb312fb7c1120e18"
);

export interface IProps {
  quickFilterText?: any;
  columnDefs: IHeader[];
  rowData: any[];
  fileName: string;
  groupDefaultExpanded?: number;
  suppressAggFuncInHeader?: boolean;
  showExcelToExport?: boolean;
  rowGroupColumns: string[];
  valueColumns: string[];
  exportData?: {};
  attrsCount: number;
  userSelection?: AgGridUserPreference;
  columnOrderChanged: (userPreferences: AgGridUserPreference) => void;
}

export interface IState {
  showToolPanel: boolean;
  rowGroupCols: string[];
  valueCols: string[];
  colIndex: number;
  movedColumn: any;
  mappedRowData: any;
  columns: string[];
  showTotals: boolean;
}
interface IExcelPayload {
  isNumber: boolean;
  isPercent: boolean;
  plainObj: any;
  value: any;
}

export const PivotAgGrid = class extends Component<IProps, IState> {
  private api?: any;
  private autoGroupColumnDef = {
    cellRendererParams: { suppressCount: true, checkbox: false },
  };
  private readonly aggFuncs = {
    sumFormatMoney: this.sumFunction,
    sumFormatVar: this.sumVariations,
  };
  constructor() {
    super();
    this.api = "";
    this.setState({
      colIndex: NaN,
      showToolPanel: false,
      showTotals: false,
    });
    this.onDragStopped = this.onDragStopped.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.fillAttributeValues = this.fillAttributeValues.bind(this);
    this.onBtnExport = this.onBtnExport.bind(this);
    this.getMainMenuItems = this.getMainMenuItems.bind(this);
    this.modeChanged = this.modeChanged.bind(this);
    this.gridStatusChanged = this.gridStatusChanged.bind(this);
  }

  public render(): JSX.Element {
    return (
      <WithGlobalCss styles={css}>
        <div style="text-align: left;" class="row">
          <div class="text-left col-md-4">
            <input
              placeholder="Quick search"
              type="text"
              style="height: 32px;"
              onInput={(x: any) => this.onQuickFilterText(x)}
            />
            <button
              style="margin-left: 10px; margin-top: 0px;"
              class="btn btn-default"
              onClick={() => this.onBtnExport()}
            >
              <span class="fa fa-file-excel-o" /> Export
            </button>
          </div>
          <div class="checkbox col-md-2" style=" margin-top: 5px;">
            <input
              type="checkbox"
              checked={this.state.showTotals}
              onChange={this.modeChanged}
            />
            <span>Show Totals</span>
          </div>
        </div>
        <div style="height: 95%; " class={`${css.locals.splAgGridBasic}`}>
          <div class="ag-theme-bootstrap" style="width: 100%; height: 90%;">
            <AgGridReact
              ref={(agGridReact: any) => {
                this.api = agGridReact;
              }}
              rowDataChangeDetectionStrategy={
                ChangeDetectionStrategyType.NoCheck
              }
              columnDefs={this.buildHeader(this.props.columnDefs)}
              enableColResize={true}
              enableFilter={true}
              enableSorting={true}
              onGridReady={this.onGridReady}
              rowData={this.props.rowData}
              pivotMode={true}
              showToolPanel={this.state.showToolPanel}
              groupMultiAutoColumn={true}
              groupDefaultExpanded={-1}
              toolPanelSuppressSideButtons={true}
              toolPanelSuppressRowGroups={true}
              toolPanelSuppressValues={true}
              suppressAggFuncInHeader={true}
              groupHideOpenParents={!this.state.showTotals}
              autoGroupColumnDef={this.autoGroupColumnDef}
              onColumnResized={this.gridStatusChanged.bind(this)}
              onDragStopped={this.onDragStopped}
              onFilterChanged={this.gridStatusChanged.bind(this)}
              onSortChanged={this.gridStatusChanged.bind(this)}
              onColumnPinned={this.gridStatusChanged.bind(this)}
              aggFuncs={this.aggFuncs}
              getMainMenuItems={this.getMainMenuItems}
            />
          </div>
          <br />
          <div style="align: right">
            <b>Units:</b>{" "}
            {this.props.fileName === "portfolio"
              ? "NBI(EURk), RWA(EURm)"
              : "SC(EURk)"}
          </div>
        </div>
      </WithGlobalCss>
    );
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    this.api.gridOptions.api.refreshInMemoryRowModel();
  }

  protected onQuickFilterText(event: any) {
    this.api.gridOptions.api.setQuickFilter(event.target.value);
  }

  private onGridReady(params: GridReadyEvent) {
    this.api.gridOptions.deltaColumnMode = true;
    this.setState({
      showToolPanel: false,
    });
    const colDefs = this.api.gridOptions.columnDefs;
    this.setState({
      columns: colDefs.map((a: any) => a.headerName),
    });

    const { userSelection } = this.props;
    if (userSelection && userSelection.columns) {
      if (isArray(userSelection.columns)) {
        userSelection.columns.forEach((x: any) => {
          if (x.pinned) {
            this.api.gridOptions.columnApi.setColumnPinned(x.colId, x.pinned);
          }
          this.api.gridOptions.columnApi.setColumnWidth(
            this.api.gridOptions.columnApi.getColumn(x.colId),
            x.actualWidth
          );
        });
      }

      if (userSelection.filter) {
        this.api.gridOptions.api.setFilterModel(userSelection.filter);
      }
      if (userSelection.sort) {
        this.api.gridOptions.api.setSortModel(userSelection.sort);
      }
    }
  }

  private modeChanged(event: any) {
    this.setState({
      showTotals: event.target.checked,
    });
  }

  private getMainMenuItems(params: any) {
    const menuItems: any[] = [];
    const itemsToExclude = [
      "valueAggSubMenu",
      "resetColumns",
      "toolPanel",
      "rowGroup",
    ];
    params.defaultItems.forEach((item: any) => {
      if (itemsToExclude.indexOf(item) < 0) {
        menuItems.push(item);
      }
    });
    return menuItems;
  }

  private sumFunction(values: any) {
    let result = 0;
    values.forEach((value: any) => {
      if (typeof value === "number") {
        result += value;
      }
    });
    return Format.FormatMoney(result, 1, 0);
  }

  private sumVariations(values: any) {
    let result = 0;
    let i = 0;
    values.forEach((val: any) => {
      const item = typeof val === "string" ? val.replace(/[,%]/g, "") : val;
      if (!isNaN(item)) {
        result += Number(item);
        i++;
      }
    });
    if (i > 0) {
      result = result / i;
    }
    return (
      (result.toString() === "Infinity"
        ? 0
        : result > 0
        ? "+" + result.toFixed(0)
        : result.toFixed(0)) + " %"
    );
  }

  private buildHeader(headerList: IHeader[]): IHeader[] {
    const result = headerList;
    result.forEach(elem => {
      const elemColDef = elem as ColDef;
      elemColDef.suppressToolPanel = true;
      elemColDef.menuTabs = ["filterMenuTab", "generalMenuTab"];
    });

    return result;
  }

  private onDragStopped(params: any) {
    if (this.isThisAResize()) {
      return;
    }
    let colDefs = this.api.gridOptions.columnDefs;
    const firstKpiIndex = this.api.gridOptions.columnApi.columnController.allDisplayedColumns
      .map((x: any) => x.aggregationActive)
      .indexOf(true);
    if (firstKpiIndex < this.props.attrsCount) {
      this.setColumnDefs(colDefs);
      return;
    }
    const colState = this.api.gridOptions.columnApi.columnController.allDisplayedColumns.map(
      (x: any) => x.colDef.headerName
    );
    colDefs = this.reOrderArrayObj(colDefs, colState, "headerName");
    this.setColumnDefs(colDefs);
    this.setState({
      columns: colDefs.map((a: any) => a.headerName),
    });
    this.gridStatusChanged();
  }

  private setColumnDefs(colDefs: any) {
    this.setWidth(
      colDefs,
      this.api.gridOptions.columnApi.columnController.allDisplayedColumns
    );
    this.api.gridOptions.api.setColumnDefs(colDefs);
  }

  private gridStatusChanged() {
    const columnState = this.api.gridOptions.columnApi.columnController.allDisplayedColumns.map(
      (x: any) => {
        return { colId: x.colId, actualWidth: x.actualWidth, pinned: x.pinned };
      }
    );
    const filterModel = this.api.gridOptions.api.getFilterModel();
    const sortModel = this.api.gridOptions.api.getSortModel();
    const gridUserPreference: AgGridUserPreference = {
      columns: columnState,
      filter: filterModel,
      sort: sortModel,
    };

    if (this.props.columnOrderChanged) {
      this.props.columnOrderChanged(gridUserPreference);
    }
  }

  private processCellCallback(params: any) {
    if (
      params.value &&
      params.column.aggFunc !== "sum" &&
      params.value.indexOf("->") > 0
    ) {
      const valueArray = params.value.split("->");
      if (valueArray.length === 2) {
        return params.value.replace("->", "").replace(" ", "");
      } else if (valueArray.length > 2) {
        return undefined;
      }
    }
    if (
      (params.column.filter && params.column.filter === "number") ||
      (params.column.colDef &&
        params.column.colDef.valueGetter === AgFormat.AgGridFormatMoney)
    ) {
      return params.value.replace(/[,%]/g, "").replace(" ", "");
    } else {
      return params.value;
    }
  }

  private onBtnExport() {
    if (this.state.showTotals) {
      const params = {
        allColumns: true,
        columnGroups: false,
        fileName: this.props.fileName,
        onlySelected: false,
        processCellCallback: this.processCellCallback,
        skipFooters: false,
        skipGroups: false,
        skipHeader: false,
        skipPinnedBottom: true,
        skipPinnedTop: true,
      };
      this.api.gridOptions.api.exportDataAsExcel(params);
    } else {
      const groupedAttrData = this.api.gridOptions.api.rowModel.rowsToDisplay.map(
        (x: any) => x.groupData
      );
      const groupedAttrFillData = groupedAttrData.reduce(
        this.fillAttributeValues,
        []
      );
      const colDefs = this.api.gridOptions.columnDefs.map((x: any) => x.field);
      const headers: any[] = this.api.gridOptions.columnDefs.map(
        (x: any) => x.headerName
      );

      const data: any[][] = new Array();
      data.push(headers);
      for (const row of groupedAttrFillData) {
        const props = this.reOrderArray(Object.keys(row), colDefs);
        data.push(
          props.map(key => {
            const formatMetaData = this.formatValue(row, key);
            return formatMetaData.isPercent
              ? `${formatMetaData.value}%`
              : this.insertExcelNumber(formatMetaData);
          })
        );
      }
      /* convert ArrayOfArray back to worksheet */
      const workSheet = XLSX.utils.aoa_to_sheet(data);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, this.props.fileName);
      XLSX.writeFile(workBook, this.props.fileName + ".xlsx");
    }
  }

  private retrieveCorrespondingRowData(current: any) {
    const foundElements = this.props.rowData.filter(element => {
      for (const prop in current) {
        if (current[prop] !== element[prop]) {
          return false;
        }
      }
      return true;
    });
    return foundElements.length > 0 ? foundElements[0] : {};
  }

  private fillAttributeValues(
    prevTotal: any[],
    current: any,
    currentIndex: number
  ) {
    const groupedKpiData = this.api.gridOptions.api.rowModel.rowsToDisplay.map(
      (x: any) => x.aggData
    );
    const currentWithPrettyPropsName: any = {};
    // tslint:disable-next-line:forin
    for (const prop in current) {
      const shortenprop = prop.replace("ag-Grid-AutoColumn-", "");
      currentWithPrettyPropsName[shortenprop] = current[prop];
      if (
        currentWithPrettyPropsName[shortenprop] === null &&
        prevTotal.length > 0
      ) {
        currentWithPrettyPropsName[shortenprop] =
          prevTotal[prevTotal.length - 1][shortenprop];
      }
    }

    const enhancedCurrent: any = this.retrieveCorrespondingRowData(
      currentWithPrettyPropsName
    );

    const currentWithAllProps: any = { ...currentWithPrettyPropsName };
    // tslint:disable-next-line:forin
    for (const kpiProp in groupedKpiData[currentIndex]) {
      currentWithAllProps[kpiProp] = enhancedCurrent[kpiProp + "_export"]
        ? enhancedCurrent[kpiProp + "_export"]
        : groupedKpiData[currentIndex][kpiProp];
    }
    prevTotal.push(currentWithAllProps);
    return prevTotal;
  }

  private isThisAResize(): boolean {
    const columnsOfProps = this.props.columnDefs.map(x => x.headerName);
    const columnsOfAgGrid = this.api.gridOptions.columnApi.columnController.allDisplayedColumns.map(
      (x: any) => x.colDef.headerName
    );
    return (
      columnsOfProps.length === columnsOfAgGrid.length &&
      columnsOfProps.every((value, index) => {
        return value === columnsOfAgGrid[index];
      })
    );
  }

  private reOrderArray(sourceArray: string[], orderedArray: string[]) {
    sourceArray.sort((a: any, b: any) => {
      if (orderedArray.indexOf(a) > orderedArray.indexOf(b)) {
        return 1;
      } else {
        return -1;
      }
    });
    return sourceArray;
  }

  private reOrderArrayObj(
    sourceArray: any[],
    orderedArray: string[],
    key: string
  ) {
    sourceArray.sort((a: any, b: any) => {
      const A = a[key];
      const B = b[key];

      if (orderedArray.indexOf(A) > orderedArray.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return sourceArray;
  }

  private setWidth(sourceArray: any[], currectArray: any[]) {
    sourceArray.forEach((x: any) => {
      const displayedColumn = currectArray.filter(
        (y: any) => y.colDef.headerName === x.headerName
      )[0];
      if (displayedColumn) {
        x.width = displayedColumn.actualWidth;
      }
    });
  }

  private formatValue(row: any, key: string): IExcelPayload {
    const colDef = this.api.gridOptions.columnDefs.filter(
      (entry: any) => entry.field === key
    );
    let isAggrSum = false;
    if (
      colDef.length > 0 &&
      colDef[0].aggFunc !== undefined &&
      colDef[0].aggFunc === "sum"
    ) {
      isAggrSum = true;
    }
    if (
      colDef.length > 0 &&
      colDef[0].cellClass !== undefined &&
      colDef[0].cellClass.includes("percent")
    ) {
      const formatted = this.tackleNumber(row[key], isAggrSum);
      formatted.isPercent = false;
      return formatted;
    } else {
      return this.tackleNumber(row[key], isAggrSum);
    }
  }

  private insertExcelNumber(formatMetaData: IExcelPayload): any {
    const excelValue = formatMetaData.value;
    if (formatMetaData.isNumber) {
      return Number(excelValue);
    } else {
      return `${excelValue}`;
    }
  }

  private tackleNumber(obj: any, isAggrSum: boolean) {
    if (!isNaN(obj)) {
      const nVal = Number(obj);
      if (Math.floor(nVal) === nVal && isAggrSum === false) {
        return {
          isNumber: false,
          isPercent: false,
          plainObj: obj,
          value: obj.toString(),
        };
      } else {
        return {
          isNumber: true,
          isPercent: false,
          plainObj: obj,
          value: obj,
        };
      }
    } else {
      return {
        isNumber: false,
        isPercent: false,
        plainObj: obj,
        value: obj,
      };
    }
  }
};
